export default __webpack_public_path__ + "static/team-3a07890ada0ebaa0b18421e980a3a105.png";